/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';
import { AppBanner as AppBannerComponent } from '@spotahome/ui-library';

import './AppBanner.scss';

const buildDeeplink = (slug = '') => {
  const sessionId =
    typeof window !== 'undefined' && window.__CONTEXT__
      ? window.__CONTEXT__.__EXPERIMENTS_SESSION_ID__
      : '';
  return `https://spotahome.app.link/${slug}${
    sessionId && `?webSessionId=${sessionId}`
  }`;
};

const PROPS_BY_SOURCE = {
  search: {
    eventAction: 'banner-click-searchpage',
    openPath: buildDeeplink('banner_search')
  },
  listing: {
    eventAction: 'banner-click-productpage',
    openPath: buildDeeplink('banner_listing')
  },
  chat: {
    eventAction: 'banner-click-chatpage',
    openPath: buildDeeplink('banner_chat')
  }
};

const AppBanner = ({ source, deviceType }) => {
  const isMobile = deviceType === 'smartphone';
  const AppBannerExperiment = useSoyuzExperiment('ModalToApp');
  const isAppBannerVariant =
    isMobile && AppBannerExperiment.get('behaviour') === 'variant';

  return isMobile ? (
    <div
      className={`app-banner-wrapper ${
        isAppBannerVariant ? 'app-banner-wrapper--new' : ''
      }`}
    >
      <AppBannerComponent
        title={trans('appbanner.title')}
        className="app-banner"
        {...PROPS_BY_SOURCE[source]}
        newBanner={isAppBannerVariant}
      />
    </div>
  ) : null;
};

AppBanner.propTypes = {
  source: PropTypes.oneOf(Object.keys(PROPS_BY_SOURCE)).isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired
};

export default AppBanner;
